export const dayOfTheWeek = (date: string | undefined): string => {
  if (!date) return '';
  const dateObj = new Date(date);
  const dayOfWeek = dateObj.getDay();
  const dayOfTheWeekList = ['日', '月', '火', '水', '木', '金', '土'];
  return dayOfTheWeekList[dayOfWeek] || '';
};

export const getTime = (date: string | undefined): Date => {
  if (date) {
    return new Date(date);
  }
  return new Date();
};

export const getDate = (date: string | undefined): string => {
  const time = getTime(date);
  return `${time.getMonth() + 1}/${time.getDate()}`;
};

export const getTimeString = (date: string | undefined): string => {
  const time = getTime(date);
  return `${time.getHours()}:${time.getMinutes()}`;
};
